'use client';

import { motion } from 'framer-motion';
import { FaStar, FaMapMarkerAlt, FaPhone, FaEnvelope, FaGlobe } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.4 }
  },
  hover: { 
    y: -5,
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
    transition: { duration: 0.2 }
  }
};

const LawFirmCard = ({ firm }) => {
  const navigate = useNavigate();
    console.log(firm) 
  // Verificar si estamos usando la estructura de datos real o la de prueba
  const isRealData = firm._id !== undefined;
  
  // Extraer los datos según la estructura
  

  // Función para navegar a la página de detalles del bufete
  const handleViewDetails = () => {
    // Enviar el objeto 'firm' directamente en el estado
    navigate(`/HomeEcommerce/PerfilBufetePage/${firm._id || firm.id}`, { state: { firmData: firm } });
  };

  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300"
    >
      <div className="relative h-48 overflow-hidden">
        <img 
          src={firm.logoImage || "/placeholder.svg"} 
          alt={firm.name} 
          className="w-full h-full object-cover"
        />
        <div className="absolute top-0 right-0 bg-white bg-opacity-90 px-3 py-1 m-2 rounded-full flex items-center">
          <FaStar className="text-yellow-500 mr-1" />
          <span className="font-semibold">{firm.rating}</span>
          <span className="text-xs text-gray-500 ml-1">({firm.reviewCount})</span>
        </div>
      </div>
      
      <div className="p-5">
        <h3 className="text-xl font-bold mb-2 text-gray-800">{firm.name}</h3>
        
        <div className="flex items-center mb-2 text-gray-600">
          <FaMapMarkerAlt className="mr-2 text-gray-500" />
          <span>{firm.location}</span>
        </div>
        
        {firm.phone && (
          <div className="flex items-center mb-2 text-gray-600">
            <FaPhone className="mr-2 text-gray-500" />
            <span>{firm.phone}</span>
          </div>
        )}
        
        {firm.email && (
          <div className="flex items-center mb-2 text-gray-600 truncate">
            <FaEnvelope className="mr-2 text-gray-500 flex-shrink-0" />
            <span className="truncate">{firm.email}</span>
          </div>
        )}
        
        {firm.website && firm.website !== "Website not defiend" && (
          <div className="flex items-center mb-2 text-gray-600">
            <FaGlobe className="mr-2 text-gray-500" />
            <span className="truncate">{firm.website}</span>
          </div>
        )}
        
        <div className="mt-3 mb-4">
          <p className="text-gray-600 line-clamp-3">{firm.description}</p>
        </div>
        
        <div className="flex flex-wrap gap-2 mb-4">
          {/* Check if tags exist before trying to map */}
          {firm.tags && firm.tags.length > 0 && firm.tags.map((tag, index) => (
            <span 
              key={index} 
              className="bg-blue-50 text-blue-700 px-2 py-1 rounded-full text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
        
        <button
          onClick={handleViewDetails}
          className="block w-full text-center bg-[var(--navy-blue)] hover:bg-[var(--navy-blue-light)] text-white py-2 rounded-md transition-colors duration-300"
        >
          Ver detalles
        </button>
      </div>
    </motion.div>
  );
};

export default LawFirmCard;
